import { render, staticRenderFns } from "./InternalMovingByArticles.vue?vue&type=template&id=ec55013c&scoped=true"
import script from "./InternalMovingByArticles.vue?vue&type=script&lang=js"
export * from "./InternalMovingByArticles.vue?vue&type=script&lang=js"
import style0 from "./InternalMovingByArticles.vue?vue&type=style&index=0&id=ec55013c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec55013c",
  null
  
)

export default component.exports